import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "trigger",
  class: "c-dropdown__trigger"
}
const _hoisted_2 = { class: "c-dropdown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdown",
    class: "c-dropdown__container",
    style: _normalizeStyle(_ctx.styleContainer)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "trigger", { toggleVisibility: _ctx.toggleVisibility }, undefined, true)
    ], 512),
    _createVNode(_Transition, {
      name: String(_ctx.hideAnimation) || 'fade'
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "c-dropdown__content",
            style: _normalizeStyle(_ctx.styleContent)
          }, [
            _renderSlot(_ctx.$slots, "content", { toggleVisibility: _ctx.toggleVisibility }, undefined, true)
          ], 4)
        ], 512), [
          [_vShow, _ctx.visibility]
        ])
      ]),
      _: 3
    }, 8, ["name"])
  ], 4))
}